import { makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";
import { changeFilter, selectFilterState } from "redux/filter";
import { useAppDispatch, useAppSelector } from "redux/store";
import { resolveQueryGQL } from "requests/meldungenRequests";
import SearchIcon from "@material-ui/icons/Search";
import { t } from "@lingui/macro";

export default function Suche() {
  const filter = useAppSelector(selectFilterState);
  const dispatch = useAppDispatch();

  const [currentSearch, setCurrentSearch] = useState<string>("");

  const classes = useStyle();

  const onKeyDown = async (e: any) => {
    if (e.code === "Backspace" && currentSearch === "") {
      const copy = [...filter.suchFelder];
      copy.pop();

      dispatch(
        changeFilter({
          ...filter,
          suchFelder: copy,
        })
      );
      return;
    }
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      if (currentSearch?.trim() === "") return;
      const alreadyExists = Boolean(
        filter.suchFelder.find(
          (s) => s.query.toLowerCase() === e.target.value.toLowerCase()
        )
      );
      if (alreadyExists) {
        setCurrentSearch(() => "");
        return;
      }
      try {
        const neueSuchfelder = await resolveQueryGQL(e.target.value);
        dispatch(
          changeFilter({
            ...filter,
            suchFelder: [...filter.suchFelder, ...neueSuchfelder],
          })
        );
        setCurrentSearch(() => "");
      } catch {
        return;
      }
    }
  };

  return (
    <div className={classes.container}>
      <SearchIcon fontSize="small" />
      <TextField
        className={classes.text}
        value={currentSearch}
        onChange={(e) => setCurrentSearch(() => e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={t({
          id: "begriff.suchzeile",
          message: "Suchen...",
        })}
        fullWidth
      />
    </div>
  );
}

const useStyle = makeStyles({
  container: {
    alignItems: "center",
    display: "inline-flex",
    flex: "auto",
  },
  text: {
    width: "100%",
    margin: "0 0.2em",
    flex: "auto",
    "& .MuiInput-underline:before": {
      borderBottomColor: "transparent", // Semi-transparent underline
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "transparent", // Solid underline on hover
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent", // Solid underline on focus
    },
  },
});
